/**
 * Definição de schema SQLite local.
 * Tabelas de domínio seguem o mesmo contrato (UUID + sync_status + soft delete).
 */

export const SQLITE_DB_NAME = 'engetel_offline_v1';
export const SQLITE_DB_VERSION = 4;

/** Tabelas que aceitam CRUD genérico via DatabaseService. */
export const OFFLINE_ENTITY_TABLES = ['field_reports', 'proposals'] as const;

export type OfflineEntityTable = (typeof OFFLINE_ENTITY_TABLES)[number];

const ENTITY_TABLE_DDL: Record<OfflineEntityTable, string> = {
  field_reports: `
    CREATE TABLE IF NOT EXISTS field_reports (
      id TEXT PRIMARY KEY,
      sync_status TEXT NOT NULL DEFAULT 'pending',
      server_id INTEGER,
      version INTEGER NOT NULL DEFAULT 0,
      data TEXT NOT NULL,
      created_at TEXT NOT NULL,
      updated_at TEXT NOT NULL,
      deleted_at TEXT
    );
  `,
  proposals: `
    CREATE TABLE IF NOT EXISTS proposals (
      id TEXT PRIMARY KEY,
      sync_status TEXT NOT NULL DEFAULT 'pending',
      data TEXT NOT NULL,
      created_at TEXT NOT NULL,
      updated_at TEXT NOT NULL,
      deleted_at TEXT
    );
  `,
};

export const SYNC_QUEUE_DDL = `
  CREATE TABLE IF NOT EXISTS sync_queue (
    id TEXT PRIMARY KEY,
    table_name TEXT NOT NULL,
    record_id TEXT NOT NULL,
    operation TEXT NOT NULL,
    payload TEXT NOT NULL,
    created_at TEXT NOT NULL,
    attempts INTEGER NOT NULL DEFAULT 0,
    last_error TEXT
  );
`;

export const SYNC_META_DDL = `
  CREATE TABLE IF NOT EXISTS sync_meta (
    key TEXT PRIMARY KEY,
    value TEXT NOT NULL
  );
`;

export const INERTIA_PAGE_CACHE_DDL = `
  CREATE TABLE IF NOT EXISTS inertia_page_cache (
    cache_key TEXT PRIMARY KEY,
    page_json TEXT NOT NULL,
    inertia_version TEXT,
    updated_at TEXT NOT NULL
  );
`;

export const FIELD_SYNC_OUTBOX_DDL = `
  CREATE TABLE IF NOT EXISTS field_sync_outbox (
    id TEXT PRIMARY KEY,
    created_at TEXT NOT NULL,
    last_push_error TEXT,
    last_push_at TEXT,
    operation_json TEXT NOT NULL
  );
`;

export const FIELD_CACHE_REPORTS_DDL = `
  CREATE TABLE IF NOT EXISTS field_cache_reports (
    report_id INTEGER PRIMARY KEY,
    client_uuid TEXT,
    report_date TEXT,
    sync_status TEXT NOT NULL,
    payload_json TEXT NOT NULL,
    updated_at TEXT NOT NULL
  );
`;

export const FIELD_CACHE_PROJECTS_DDL = `
  CREATE TABLE IF NOT EXISTS field_cache_projects (
    project_id INTEGER PRIMARY KEY,
    payload_json TEXT NOT NULL,
    updated_at TEXT NOT NULL
  );
`;

export const FIELD_RDO_DRAFTS_DDL = `
  CREATE TABLE IF NOT EXISTS field_rdo_drafts (
    draft_key TEXT PRIMARY KEY,
    client_uuid TEXT NOT NULL,
    project_id INTEGER NOT NULL,
    payload_json TEXT NOT NULL,
    updated_at TEXT NOT NULL
  );
`;

export function isOfflineEntityTable(name: string): name is OfflineEntityTable {
  return (OFFLINE_ENTITY_TABLES as readonly string[]).includes(name);
}

export function migrationStatements(): string[] {
  return [
    SYNC_QUEUE_DDL,
    SYNC_META_DDL,
    INERTIA_PAGE_CACHE_DDL,
    FIELD_SYNC_OUTBOX_DDL,
    FIELD_CACHE_REPORTS_DDL,
    FIELD_CACHE_PROJECTS_DDL,
    FIELD_RDO_DRAFTS_DDL,
    ...OFFLINE_ENTITY_TABLES.map((table) => ENTITY_TABLE_DDL[table]),
    `CREATE INDEX IF NOT EXISTS idx_sync_queue_pending ON sync_queue(attempts, created_at);`,
    `CREATE INDEX IF NOT EXISTS idx_field_reports_sync ON field_reports(sync_status);`,
    `CREATE INDEX IF NOT EXISTS idx_field_sync_outbox_created ON field_sync_outbox(created_at);`,
    `CREATE INDEX IF NOT EXISTS idx_field_cache_reports_date ON field_cache_reports(report_date);`,
    `CREATE INDEX IF NOT EXISTS idx_field_rdo_drafts_project ON field_rdo_drafts(project_id);`,
  ];
}
